"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _Button = _interopRequireDefault(require("../Button"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 600;\n  color: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    font-size: 1.5rem;\n  }\n\n  &:last-child {\n    text-align: right;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  text-align: left;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  border-collapse: collapse;\n  border: none;\n  margin-bottom: 15px;\n\n  tbody tr {\n    border-bottom: 1px solid rgba(140, 146, 157, 0.4);\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  td {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = _styledComponents.default.table(_templateObject());

var TableHead = _styledComponents.default.thead(_templateObject2(), _Constant.Color.DARK_GREY);

var TH = _styledComponents.default.th(_templateObject3(), _Constant.Color.BLACK_SOUL, _Constant.Width.MD);

var TitleTable = function TitleTable(_ref) {
  var header = _ref.header,
      handleLink = _ref.handleLink,
      buttonText = _ref.buttonText,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(TableHead, null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement(TH, null, header), /*#__PURE__*/_react.default.createElement(TH, null, buttonText && /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleLink,
    secondary: true,
    large: true
  }, buttonText)))), children);
};

TitleTable.propTypes = {
  /** The header text */
  header: _propTypes.default.string.isRequired,

  /** The function for the button if buttonText is passed */
  handleLink: _propTypes.default.func,

  /** If passed a button will be rendered */
  buttonText: _propTypes.default.string,

  /** What will be rendered in the table */
  children: _propTypes.default.node.isRequired
};
TitleTable.defaultProps = {
  handleLink: null,
  buttonText: ''
};
var _default = TitleTable;
exports.default = _default;